/*
 * @Description: 项目管理
 * @Author: lijinpeng
 * @Date: 2022-10-09 14:47:28
 * @LastEditTime: 2023-05-24 11:06:29
 * @LastEditors: WangYuhan
 */

import { get, post, deleted, prefix } from './base';

// 项目列表查询
export function postProjectPageList(data) {
  return post(`${prefix}project/pageList`, data);
}

// 根据企业ID查询项目列表
export function getProjectListByBid(params) {
  return get(`${prefix}project/group/business/projectList`, params);
}

// 项目新增
export function postProjectAdd(data) {
  return post(`${prefix}project/add`, data);
}

// 项目编辑
export function postProjectUpdate(data) {
  return post(`${prefix}project/update`, data);
}

// 根据ID删除项目
export function deleteProject(params) {
  return deleted(`${prefix}project/delete`, params);
}

// 项目导出
export const projectExportUrl = `${prefix}project/list/export`;

// 根据项目ID查询项目详情
export function getProjectDetailById(params) {
  return get(`${prefix}project/getById`, params);
}

// 根据企业ID查询项目负责人
export function getProjectLeaderList(params) {
  return get(`${prefix}project/group/leaders`, params);
}

// 根据企业ID查询项目成员
export function getProjectMemberList(params) {
  return get(`${prefix}project/group/members`, params);
}

// 根据企业ID查询项目线路关联关系
export function getProjectRouteInfoTree(params) {
  return get(`${prefix}project/group/tree/projectRouteInfo`, params);
}
